@if (details$ | async; as details) {
  <app-warehouse-receipt-details-attributes
    [id]="details.id"
    [status]="details.status"
    [number]="details.number"
    [comment]="details.comment"
    [createdAt]="details.createdAt"
    [approvedAt]="details.approvedAt"
    [receiptedAt]="details.receiptedAt" />

  <div class="mt-3">
    <app-details-view label="Produkty">
      <div class="rounded-lg border border-gray-200 p-4">
        <p-accordion [multiple]="true">
          @for (
            product of details.products;
            track product.id;
            let index = $index
          ) {
            <p-accordion-panel [value]="index">
              <p-accordion-header>
                <div class="flex items-center gap-2 text-sm text-gray-400">
                  <span>#{{ index + 1 }}</span>
                  <span>{{ product.name }}</span>
                </div>
              </p-accordion-header>

              <p-accordion-content>
                <app-warehouse-receipt-product-details-attributes
                  [unit]="product.unit"
                  [type]="product.type"
                  [id]="product.id"
                  [name]="product.name"
                  [batchNumber]="product.batchNumber"
                  [brand]="product.brand"
                  [durabilityInformation]="product.durabilityInformation"
                  [ownerId]="product.ownerId"
                  [promotion]="product.promotion"
                  [quantity]="product.quantity"
                  [sku]="product.sku" />
              </p-accordion-content>
            </p-accordion-panel>
          }
        </p-accordion>
      </div>
    </app-details-view>
  </div>

  @if (thumbnailsVisibility()) {
    @if (details.files) {
      <app-multimedia-galleria-thumbnails
        [files]="details.files"
        [fetchMultimediaDetailsFn]="fetchMultimediaDetailsFn" />
    }
  }
} @else {
  <app-spinner-filled />
}
